export default function CloseIcon() {
  return (
    <>
      <line x1='18' y1='6' x2='6' y2='18' fill='none' />
      <line x1='6' y1='6' x2='18' y2='18' fill='none' />
    </>
  );
}
